import React, { Component } from "react";
import { useEffect } from "react";
import { useState } from "react";
import Nestable from "react-nestable";
import { AxiosPost } from "../../../context/UserContext";
import { pushNotify } from "../../../services/NotifyService";
import EditBudget from "./EditBudget";
import "./style.css"
import AddCategory from "../CategoryMaster/AddCategory"
import DeleteCategory from "../CategoryMaster/DeleteCategory";
import CustomizedTreeView from "./CustomizedTreeView";
import EditParent from "./EditParent";
import GridTree from 'react-gridtree';

const Budgeting = () => {
    const [defaultCollapsed, setDefaultCollapsed] = useState(true);
    const [isLoading, setIsLoading] = useState(false)
    const [treeItems, setTreeItems] = useState([]);
    const [parentCategoryOptions, setparentCategoryOptions] = useState([{ value: "-1", label: "Fetching Please wait..." }]);
    const [actualSpent, setActualSpent] = useState([]);
    const [estBudgets, setEstBudgets] = useState([])
    const [categoryIds, setCategoryIds] = useState("100")
    const [rawcategories, setRawcategories] = useState([])

    const [categoryOptions, setCategoryOptions] = useState(null);

    const getSpent = (id, actual_spent = actualSpent) => {
        let sum = 0
        for (let index = 0; index < actual_spent.length; index++) {
            let idarray = actual_spent[index].category_id_desc.split("->")
            if (idarray.includes(id)) sum += parseInt(actual_spent[index].total)
        }
        return sum
    }

    const getSumOfEstimatedBudgets = (id, estimated_budgets = estBudgets) => {
        let sum = 0
        for (let index = 0; index < estimated_budgets.length; index++) {
            let idarray = estimated_budgets[index].category_id_desc.split("->")
            if (idarray.includes(id)) sum += parseInt(estimated_budgets[index].estimated_budget)
        }
        return sum
    }

    const renderItem = ({ item, collapseIcon, handler }) => {
        return (
            <div>
                {handler}
                {collapseIcon}
                {item.text}
                <span style={{ "marginLeft": "15px" }}>
                    Estimated Budget: {Intl.NumberFormat('en-IN', { style: 'currency', currency: 'INR' }).format(item.estimated_budget)}
                </span>
                <span style={{ "marginLeft": "15px" }}>
                    Actual Spent: {Intl.NumberFormat('en-IN', { style: 'currency', currency: 'INR' }).format(getSpent(item.id))}
                </span>
            </div>
        );
    };


    const fetchOptions2 = async () => {
        try {
            setIsLoading(true);
            const data = await AxiosPost('fetch_category_options.php');
            if (data.success) {
                setCategoryOptions(data.options)
            }
            else {
                pushNotify("error", "Error", data.error)
            }
        } catch {
            pushNotify("error", "Error", "Server Error!")
        } finally {
            setIsLoading(false)
        }
    }

    const fetchOptions = async () => {
        try {
            setIsLoading(true);
            const data = await AxiosPost('fetch_parent_category_options.php');
            console.log(data)
            if (data.success) {
                setparentCategoryOptions(data.options)
            }
            else {
                pushNotify("error", "Error", data.error)
            }
        } catch {
            pushNotify("error", "Error", "Server Error!")
        } finally {
            setIsLoading(false)
        }
    }
    const prepareRawCategories = (categories, actual_spent, estimated_budgets) => {
        let tempstats = []
        let colorcode = "hsl(" + Math.random() * 360 + ", 100%, 75%)";
        categories.map((category) => {
            let temp = { category_name: "", estimated: "", actual: "", variance: "", leaf: category.leaf, background: colorcode, color: "black" }
            temp.category_name = category.category_name
            temp.actual = getSpent(category.category_id, actual_spent)
            if (category.leaf != '1') {
                colorcode = "hsl(" + Math.random() * 360 + ", 100%, 75%)";
                temp.background = colorcode
                temp.estimated = Intl.NumberFormat('en-IN', { style: 'currency', currency: 'INR' }).format(getSumOfEstimatedBudgets(category.category_id, estimated_budgets) - category.estimated_budget)
            } else {
                temp.estimated = Intl.NumberFormat('en-IN', { style: 'currency', currency: 'INR' }).format(category.estimated_budget)
            }

            if (category.leaf == '1') {
                temp.variance = (temp.actual * 100 / category.estimated_budget).toFixed(2)
                if (temp.variance > 100) temp.color = "red"
            } else {
                temp.variance = (temp.actual * 100 / (getSumOfEstimatedBudgets(category.category_id, estimated_budgets) - category.estimated_budget)).toFixed(2)
            }
            temp.actual = Intl.NumberFormat('en-IN', { style: 'currency', currency: 'INR' }).format(temp.actual)
            temp.variance = temp.variance + "%"
            tempstats.push(temp)
        })
        setRawcategories(tempstats)
    }

    const fetchCategories = async () => {
        try {
            setIsLoading(true);
            const data = await AxiosPost('fetch_categories.php');
            console.log(data)
            if (data.success) {
                let temp = Object.values(data.category)
                console.log(temp)
                prepareItems(temp, data.actual_spent, data.estimated_budgets)
                setTreeItems(temp)
                setActualSpent(data.actual_spent)
                setEstBudgets(data.estimated_budgets)
                setCategoryIds(data.ids)
                prepareRawCategories(data.raw_categories, data.actual_spent, data.estimated_budgets)
            }
            else {
                pushNotify("error", "Error", data.error)
            }
        } catch {
            pushNotify("error", "Error", "Server Error!")
        } finally {
            setIsLoading(false)
        }
    }

    useEffect(() => {
        fetchCategories()
    }, [])

    // useEffect(() => {
    //     execPrepareItems()
    // }, [treeItems])

    const execPrepareItems = () => {
        let temp = Object.values(treeItems)
        prepareItems(temp)
        console.log(temp)
    }

    const prepareItems = (items,actuals,estimateds) => {
        items.map(item => {
            item.actual = getSpent(item.id,actuals)
            if (item.leaf != '1') {
                item.estimated = Intl.NumberFormat('en-IN', { style: 'currency', currency: 'INR' }).format(getSumOfEstimatedBudgets(item.id,estimateds) - item.estimated_budget)
            } else {
                item.estimated = Intl.NumberFormat('en-IN', { style: 'currency', currency: 'INR' }).format(item.estimated_budget)
            }

            if (item.leaf == '1') {
                item.variance = (item.actual * 100 / item.estimated_budget).toFixed(2)
                if (item.variance > 100) item.color = "red"
            } else {
                item.variance = (item.actual * 100 / (getSumOfEstimatedBudgets(item.id,estimateds) - item.estimated_budget)).toFixed(2)
            }
            item.actual = Intl.NumberFormat('en-IN', { style: 'currency', currency: 'INR' }).format(item.actual)
            if(item.children.length!=0)prepareItems(item.children,actuals,estimateds)
            else item.children=null
        })
    }

    return (
        <div>
            <div className="col-md-12">
                <div className="card" style={{ "height": "fit-content" }}>
                    <div className="card-header border-0 pb-0">
                        <h4 className="card-title">Budgets</h4>
                    </div>
                    <div className="card-body">
                        <CustomizedTreeView rawcategories={rawcategories} setRawcategories={setRawcategories} isLoading={isLoading} categoryIds={categoryIds} getSpent={getSpent} getSumOfEstimatedBudgets={getSumOfEstimatedBudgets} items={treeItems}></CustomizedTreeView>
                        {/*{treeItems!=null || !isLoading?<Nestable
                            items={Object.values(treeItems)}
                            collapsed={true}
                            renderItem={renderItem}
                            maxDepth={30}
                        />:null}*/}
                    </div>
                </div>
            </div>
            <div className="col-md-12 row">
                {
                    localStorage.getItem('privilege') != "prod" ?
                        <>
                            <div className="col-md-4">
                                <AddCategory fetchOptions={fetchOptions} fetchOptions2={fetchOptions2} parentCategoryOptions={parentCategoryOptions} fetchCategories={fetchCategories}></AddCategory>
                            </div>
                            <div className="col-md-4">
                                <EditBudget fetchOptions={fetchOptions2} parentCategoryOptions={parentCategoryOptions} fetchCategories={fetchCategories}></EditBudget>
                            </div>
                            <div className="col-md-4">
                                <EditParent fetchOptions={fetchOptions} categoryOptions={categoryOptions} parentCategoryOptions={parentCategoryOptions} fetchCategories={fetchCategories}></EditParent>
                            </div>
                            <div className="col-md-4">

                                <DeleteCategory fetchOptions={fetchOptions} fetchOptions2={fetchOptions2} parentCategoryOptions={categoryOptions} fetchCategories={fetchCategories}></DeleteCategory>
                            </div>
                        </>
                        : null
                }
            </div>
        </div>
    );
}

export default Budgeting;
